module.exports = __webpack_public_path__ + "static/media/community_icon.34828149.svg";